<template>
  <div>
    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  
    <CalendarViewModal
      :isShow="isCalendarShow"
      :calendar="selectedItem"
      :selectedCalendars="selectedCalendars"
      @close="isCalendarShow = false"
    ></CalendarViewModal>
    <CalendarDownloaderModal
      :isShow="isDownloadShow"
      :calendar="selectedItem"
      :calendars="calendars"
      @close="
        selectedItem = null;
        isDownloadShow = false;
      "
    ></CalendarDownloaderModal>
    <div class="topBar">
    <v-breadcrumbs
      :items="breadcrumbs"
      large
      style="padding-bottom: 0px;"
    ></v-breadcrumbs>
    <v-snackbar
      timeout="2000"
      v-model="snackbar"
      
      color="secondary"
    >
     <v-icon class="mr-2">mdi-information</v-icon> <span style="font-size:16px" class="mt-2"> {{alertMsg}} </span>

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <v-row class="ml-3 mr-5 mt-2">
      <!-- <v-btn class="ml-8" color="secondary" v-if="canDownloadAll()"
        ><v-icon dark>mdi-download</v-icon>Download</v-btn
      >-->
      <v-btn
        color="white"
        :class="selectedCalendars.length > 0 ? 'primary ml-1 mr-2 mb-1' : 'grey ml-1 mr-2 mb-1'"
        width="100"
        outlined
        @click="viewAll()"
        >View</v-btn
      >
    
      <v-btn
        color="white"
        :class="selectedCalendars.length > 0 ? 'primary ml-1 mr-2 mb-1' : 'grey ml-1 mr-2 mb-1'"
        outlined
        @click="subscribeAll()"
        >Add to My Calendar</v-btn
      >
        <v-btn
        color="white"
        :class="selectedCalendars.length > 0 ? 'primary ml-1 mr-2 mb-1' : 'grey ml-1 mr-2 mb-1'"
        outlined
        @click="downloadAll()"
        >Export</v-btn
      >
      <v-spacer></v-spacer>
      <!-- <v-tooltip bottom color="primary">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            @click="style = 1"
            class="mr-1"
            v-bind="attrs"
            v-on="on"
            color="white"
            ><v-icon>mdi-grid-large</v-icon></v-btn
          >
        </template>
        <span>Grid Mode</span>
      </v-tooltip>
      <v-tooltip bottom color="primary">
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="style = 2" v-bind="attrs" v-on="on" color="white"
            ><v-icon>mdi-format-list-bulleted</v-icon></v-btn
          >
        </template>
        <span>List Mode</span>
      </v-tooltip>-->
    </v-row>
    </div>
    <v-row v-if="style == 1" class="ml-5 mr-5" style="padding-top:110px">
      <v-col
        v-for="item in calendars"
        :key="item.identity"
        cols="12"
        sm="6"
        md="4"
        lg="3"
      >
        <v-card
          style="width: 100%"
          :color="isSelected(item) ? '#bebebe' : 'white'"
        >
         <div
            style="width: 100%; height: 8px"
            :class="!isSelected(item) ? 'primary' : 'secondary'"
          ></div>
          <div class="d-flex justify-end mt-1 mr-1">
            <v-icon v-if="isSelected(item)" large>mdi-checkbox-marked-outline</v-icon>
             <v-icon v-if="!isSelected(item)" large>mdi-checkbox-blank-outline</v-icon>
          </div>
          <div class="mt-3 pt-3 pb-3" @click="selectCalendar(item)">
            <v-icon class="ma-4" style="font-size: 120px"
              >mdi-calendar-month-outline</v-icon
            >
          
            <p style="font-size: 18px; font-weight: 400">
              {{ item.name }}
            </p>
          </div>
          <!--    <div>
            <v-divider class="primary"></v-divider>

            <v-row class="mt-1 mb-1">
              <v-col cols="4">
                <v-tooltip top color="primary">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mx-2"
                      fab
                      dark
                      small
                      color="#007ca7"
                      v-bind="attrs"
                      v-on="on"
                      @click="showDetails(item)"
                    >
                      <v-icon dark>mdi-calendar-search </v-icon>
                    </v-btn>
                  </template>
                  <span>View Calendar</span>
                </v-tooltip>
              </v-col>
              <v-divider vertical></v-divider>
              <v-col cols="4">
                <v-tooltip top color="primary">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mx-2"
                      fab
                      dark
                      small
                      color="#007ca7"
                      v-bind="attrs"
                      v-on="on"
                      @click="download(item)"
                    >
                      <v-icon dark> mdi-download </v-icon>
                    </v-btn>
                  </template>
                  <span>Download Calendar</span>
                </v-tooltip>
              </v-col>
              <v-divider vertical></v-divider>

              <v-col cols="4">
                <v-tooltip top color="primary">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mx-2"
                      fab
                      dark
                      small
                      color="#007ca7"
                      v-bind="attrs"
                      v-on="on"
                      :disabled="!item.canSubscribe"
                      @click="subscribe(item)"
                    >
                      <v-icon dark> mdi-calendar-import </v-icon>
                    </v-btn>
                  </template>
                  <span>Subscribe Calendar</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </div>-->
        </v-card>
      </v-col>
    </v-row>

    <v-data-table
      v-if="style == 2"
      :items="calendars"
      :headers="headers"
      item-key="identity"
      style="width: 96%; margin-left: 2%"
    >
      <template v-slot:item.actions="{ item }">
        <v-tooltip top color="primary">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              @click="showDetails(item)"
              class="mr-2"
              v-bind="attrs"
              v-on="on"
              >mdi-calendar-search</v-icon
            >
          </template>
          <span>View Calendar</span>
        </v-tooltip>

        <v-tooltip top color="primary">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              @click="download(item)"
              class="mr-2"
              v-bind="attrs"
              v-on="on"
              >mdi-download</v-icon
            >
          </template>
          <span>Download</span>
        </v-tooltip>

        <v-tooltip top color="primary">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              @click="subscribe(item)"
              class="mr-2"
              :disabled="!item.canSubscribe"
              v-bind="attrs"
              v-on="on"
              >mdi-calendar-import</v-icon
            >
          </template>
          <span>Subscribe</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { calService } from "@/api/cal-service";
import CalendarViewModal from "@/components/Modals/CalendarViewModal";
import CalendarDownloaderModal from "@/components/Modals/CalendarDownloaderModal";

export default {
  name: "MyCalendar",
  components: { CalendarViewModal, CalendarDownloaderModal },
  computed: {
    ...mapGetters(["userProfile"]),
  },
  data: () => {
    return {
      alertMsg: 'Please select calendar(s) you want to view.',
      snackbar: true,
      style: 1,
      isLoading: false,
      isCalendarShow: false,
      isDownloadShow: false,
      selectedItem: {
        name: "",
        events: [],
        canPublish: true,
        canSubscribe: true,
      },
      calendars: [],
      selectedCalendars: [],
      selectedItems: [],
      headers: [
        { text: "Name", value: "name", width: "20%" },
        { text: "Description", value: "description", width: "42%" },
        { text: "Owner", value: "owner", width: "25%" },
        { text: "Actions", value: "actions" },
      ],
      breadcrumbs: [
        {
          text: "< Home",
          href: "",
          disabled: false,
          href: "/",
        },
        {
          text: "My Calendars",
          href: "",
          disabled: false,
        },
      ],
    };
  },
  methods: {
    showDetails(item) {
      this.selectedItem = item;
      this.isCalendarShow = true;
    },
    canDownloadAll() {
      if (this.style == 2 && this.selectedItems.length > 0) return true;
      return false;
    },
    subscribe(item) {
      let yes = confirm("Do you wish to add this calendar to your device?");
      if (yes) {
        let _url =
          process.env.VUE_APP_HOST +
          "api/Calendar/" +
          item.identity +
          "/users/" +
          this.userProfile.identity +
          "/ics";

        _url = _url.replace("https", "webcal").replace("http", "webcal");

        window.open(_url, "_blank");
      }
    },
    download(item) {
      this.selectedItem = item;
      this.isDownloadShow = true;
    },
    selectCalendar(item) {
      let idx = this.selectedCalendars.findIndex(
        (x) => x.identity == item.identity
      );
      if (idx == -1) this.selectedCalendars.push(item);
      else this.selectedCalendars.splice(idx, 1);
      //console.log(this.selectedCalendars);
    },
    isSelected(item) {
      let idx = this.selectedCalendars.findIndex(
        (x) => x.identity == item.identity
      );
      if (idx == -1) return false;
      return true;
    },
    combinedCalendars() {
      this.selectedItem = {
        name: "",
        events: [],
        canPublish: true,
        canSubscribe: true,
      };
      let idx = 0;
      this.selectedCalendars.forEach((cal) => {
        this.selectedItem.name = this.selectedItem.name
          ? this.selectedItem.name + "#" + cal.name
          : cal.name;
        //this.selectedItem.events= this.selectedItem.events.concat(cal.events)
        cal.events.forEach((e) => {
          e.index = idx;
          this.selectedItem.events.push(e);
        });
        this.selectedItem.canPublish =
          this.selectedItem.canPublish && cal.canPublish;
        this.selectedItem.canSubscribe =
          this.selectedItem.canSubscribe && cal.canSubscribe;
        idx++;
      });
    },
    viewAll() {
      if (this.selectedCalendars.length == 0)
      {
        this.alertMsg = 'Please select calendars(s) first'
        this.snackbar = true;
        return;
      }
      this.combinedCalendars();
      this.isCalendarShow = true;
    },
    async downloadAll() {
      if (this.selectedCalendars.length == 0)
      {
        this.alertMsg = 'Please select calendars(s) first'
        this.snackbar = true;
        return;
      }
      this.combinedCalendars();
      this.isDownloadShow = true;

      /*let yes = confirm('Do you want to download your selected calendar(s) as Excel file')
      if (yes)
      {
        this.isLoading = true;
        this.selectedItem.name = this.selectedItem.name
        var result = await calService.generateExcel(this.selectedItem)
        this.isLoading = false;
        //await calService.downloadExcel(result)
        let _url = process.env.VUE_APP_HOST +
          "api/calendar/download/"+result
        window.location = _url 
      }*/
    },
    async subscribeAll() {
      if (this.selectedCalendars.length == 0)
      {
        this.alertMsg = 'Please select calendars(s) first.'
        this.snackbar = true;
        return;
      }
      //this.combinedCalendars();
      let yes = true;
      //let yes = confirm("Do you want to subscribe your selected calendar(s)?");
      if (yes) {
        let _ids = [];
        this.selectedCalendars.forEach((cal) => {
          _ids.push(cal.identity);
        });
        let _id = "";
        _id = await calService.createCustomCal(
          this.userProfile.identity,
          _ids
        );
        //alert(_id)
        if (_id != "") {
          let _url =
            process.env.VUE_APP_HOST +
            "api/Calendar/custom/" +
            _id +
            "/users/" +
            this.userProfile.identity +
            "/ics";

          _url = _url.replace("https", "webcal").replace("http", "webcal");
          setTimeout(() => window.open(_url, "_blank"))
          //window.open(_url, "_blank");
        }
      }
    },
  },
  async mounted() {
    let _style = localStorage.getItem("ecal.style");
    if (_style) this.style = _style;
    this.isLoading = true;
    this.calendars = await calService.getMyCal();
    this.isLoading = false;
    if (!this.userProfile) await this.$store.dispatch("getUserProfile");
  },
  watch: {
    style(val) {
      localStorage.setItem("ecal.style", val);
    },
  },
};
</script>

<style>
.topBar {
  height: 80px;
  width: 100%;
  position: fixed;
  z-index: 9;
}
</style>